/*
    Centralizador del manejo de evento 'scroll' para evitar múltiples listeners
    individuales en cada componente que lo requiera. Todos los callbacks suscritos
    se actualizan solo cuando la condición cambia.
*/

const listeners = new Set<(isScrolled: boolean) => void>();

export const subscribeToScroll = (callback: (isScrolled: boolean) => void) => {
    listeners.add(callback);
    return () => listeners.delete(callback);
};

let previousIsScrolled = false;

const handleScroll = () => {
    const isScrolled = window.scrollY > 0;

    if (isScrolled !== previousIsScrolled) {
        previousIsScrolled = isScrolled;
        listeners.forEach((callback) => callback(isScrolled));
    }
};

if (typeof window !== "undefined") {
    if (!window.__scrollManagerInitialized) {
        window.addEventListener("scroll", handleScroll);
        window.__scrollManagerInitialized = true;
    }
}
